import React from 'react';
import ReactWordcloud from 'react-wordcloud';

import ActionLink from './ActionLink';

const WordCloud = (props) => {
	const is_builder = props?.is_builder ?? false;

	const font_size_multiplier = 1.4;
	const min_size = font_size_multiplier * 10;
	const max_size = font_size_multiplier * 40;
	const max_words = 150;
	const min_word_length = 4;
	const max_rotation = 45;
	const process_words_by = 200;

	const avoid_words = /^(dels|esto|esta|pero|però|with|because|from|shall|must|have|this|copy)$/;

	const avail_colors = props?.colors ?? ['#2951CC', '#4BC319', '#F5A000', '#85428E', '#CA4646', '#000000', '#3B5998', '#C42E35', '#55ACEE', '#5C913B', '#CB2027', '#CC181E', '#44BBFF', '#2895F1', '#BB4741', '#2DA5DC', '#00BE0F', '#64D422', '#FFB400', '#D93175'];

	const getWordFrequency = (string) => {
		const words_arr = string.replace(/[\.,-\/#!$%\^&\*;:{}=\-_`~()¿\?¡!]/g, "").toLowerCase().split(" ");
		const words_cleaned = [];
		const frequencies = {};

		let processed_words = 0;
		while(processed_words < words_arr.length) {
			const sub_words = words_arr.slice(processed_words, processed_words + process_words_by);

			sub_words.map((_word) => {
				let this_word = _word.replace("’", "'");

				if(this_word.match(avoid_words) == null) {
					// we only keep the long part of a word containing "'" or "-" (i.e. "she's" => "she")
					if(this_word.indexOf("'") > -1) {
						const foo_1 = this_word.split("'");
						this_word = (foo_1[0].length > foo_1[1].length) ? foo_1[0] : foo_1[1];
					}

					if(this_word.indexOf("-") > -1) {
						const foo_2 = this_word.split("-");
						this_word = (foo_2[0].length > foo_2[1].length) ? foo_2[0] : foo_2[1];
					}

					words_cleaned.push(this_word);
				}
			});

			for(let i = 0; i < words_cleaned.length; i++) {
				const word = words_cleaned[i];

				if(word.length >= min_word_length) {
					frequencies[word] = frequencies[word] || 0;
					frequencies[word]++;
				}
			}

			processed_words += sub_words.length;
		}

		const words_keys = Object.keys(frequencies);

		const words_selection = words_keys.sort((a, b) => {
			return frequencies[b] - frequencies[a];
		}).slice(0, max_words);

		const words_ok = [];
		words_selection.map((item) => {
			words_ok.push({ text:item.toUpperCase(), value:frequencies[item] });
		});

		return words_ok;
	};

	const words = getWordFrequency(props?.words ?? []);

	return (
		<div>
			<div class="gui_word_cloud">
				<ReactWordcloud
					options={{
						rotationAngles:[0, max_rotation],
						fontSizes:[min_size, max_size],
						fontFamily:"Arial",
						fontWeight:'bold',
						padding:3,
						deterministic:true,
					}}
					callbacks={{
						getWordColor:(word) => {
							return avail_colors[word.value % avail_colors.length];
						},
					}}
					size={[(props?.width ?? 800), (props?.height ?? 500)]}
					words={words}
				/>
			</div>

			{(words && is_builder && props.display_raw_data != undefined) && (
				<ActionLink
					onClick={() => props.display_raw_data(words)}
				>View RAW data</ActionLink>
			)}
		</div>
	)
};

export default WordCloud;